import { useTranslation } from 'next-i18next';
import { FC, useMemo } from 'react';

import { pathFor } from '../../helpers/links';
import { BreadcrumbsList } from '../Layout/Breadcrumbs/BreadcrumbsList';

interface JournalsBreadcrumbsProps {
  basePath?: {
    href: string;
    name: string;
  };
  handleClick: (item: { href: string; name: string }) => void;
  title?: string;
}

export const JournalsBreadcrumbs: FC<JournalsBreadcrumbsProps> = ({
  basePath,
  handleClick,
  title,
}) => {
  const { t } = useTranslation('insights');

  const items = useMemo(() => {
    const crumbs = [
      { href: pathFor({ page: 'INSIGHTS_INDEX' }), name: t('allInsights') },
    ];
    if (basePath) {
      crumbs.push(basePath);
    }
    if (title) {
      crumbs.push({ href: '', name: title });
    }
    return crumbs;
  }, [basePath, title, t]);

  return <BreadcrumbsList items={items} onClick={handleClick} />;
};
